/**
 * HELPER_PROVIDERS
 */
import { AuthGuard, LoginSuccess } from './auth-guard';
import { GlobalRouteGuard } from './global-route-guard';
import { PermissionGuard } from './permission-guard/permission.guard';
import { TranslationGuard } from './i18n-guard/translation.guard';
export * from './after-transition-scheduler';

export const HELPER_PROVIDERS: any[] = [
  AuthGuard,
  LoginSuccess,
  PermissionGuard,
  GlobalRouteGuard,
  TranslationGuard,
];
